export default "/_next/static/chunks/fonts/Montserrat SemiBold-757c7afa6fca8b9fae9b23c03abd9ff1.otf";